// ...
export default Object.freeze({
  1: 'Attachment',
  2: 'Generated',
  3: 'VariableAttachment',
  4: 'TableAttachment',
  5: 'CommentAttachment',
});
